import {useState, useEffect} from 'react';

function useResizeListener() {
    const [listeners, setListeners] = useState({});
    const [size, setSize] = useState({
        width: window?.innerWidth,
        height: window?.innerHeight,
    });

    const registerResizeListener = (name, callback) => {
        setListeners({
            ...listeners,
            [name]: callback,
        });
    };

    const unregisterResizeListener = name => {
        const {[name]: deadListener, ...others} = listeners;
        setListeners(others);
    };

    // Handler to call on window resize
    const handleResize = () => {
        const newSize = {
            width: window.innerWidth,
            height: window.innerHeight,
        };
        Object.values(listeners).forEach(listener => {
            listener(size, newSize);
        });
        setSize(newSize);
    };

    useEffect(() => {
        // Add event listener
        window.addEventListener('resize', handleResize);

        // Remove event listener on cleanup
        return () => window.removeEventListener('resize', handleResize);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [listeners]); // Empty array ensures that effect is only run on mount

    return {
        registerResizeListener,
        unregisterResizeListener,
    };
}

export default useResizeListener;
